import PropTypes from 'prop-types';
import React, { lazy, useCallback, useMemo } from 'react';

import './AttachmentViewer.scss';
import useTranslation from '../../hooks/useTranslation';

const ViewerStl = lazy(() => import('./components/stl').then((mod) => ({ default: mod.ViewerStl, })));
const ViewerDcm = lazy(() => import('./components/dcm/ViewerDcm'));
const ImageViewerFindings = lazy(() => import('../ImageViewer/ImageViewerFindings'));

export function Viewer({
  name, src, file, mimetype, list, containerStyle = {}, viewerClass = {},
}) {
  const { t, } = useTranslation();
  const openFile = useCallback(() => {
    window.open(src, '_blank');
  }, [src]);
  const attachmentJSX = useMemo(() => {
    if (mimetype.toLowerCase().startsWith('image/')) {
      console.log('RETURN IMAGE TYPE');
      return <ImageViewerFindings key={file.key || file.id} file={file} />;
    }
    if (mimetype.startsWith('video/')) {
      return (
        <div className="video-container" style={containerStyle}>
          <video controls>
            <track kind="captions" />
            <source src={src} type={mimetype} />
            {t('Your browser does not support the video tag.')}
          </video>
        </div>
      );
    }
    if (mimetype.startsWith('application/pdf')) {
      return (
        <div className="pdf-container" style={containerStyle}>
          <embed src={src} />
        </div>
      );
    }
    if (
      name.endsWith('doc')
      || name.endsWith('docx')
      || name.endsWith('ppt')
      || name.endsWith('pptx')
      || name.endsWith('xls')
      || name.endsWith('xlsx')
    ) {
      return (
        <div className="office-file-container" style={containerStyle}>
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${src}`}
            title={t('Attachment')}
          >
            {t('This is an embedded ')}
            <a href="http://office.com" rel="noopener noreferrer" target="_blank">
              Microsoft Office
            </a>
            {t('document, powered by')}
            <a href="http://office.com/webapps" rel="noopener noreferrer" target="_blank">
              Office Online
            </a>
          </iframe>
        </div>
      );
    }
    if (name.toLowerCase().endsWith('stl')) {
      return (
        <div className="stl-container" style={containerStyle}>
          {src && <ViewerStl src={src} />}
        </div>
      );
    }
    if (name.toLowerCase().endsWith('dcm')) {
      return (
        <div className="dcm-container" style={containerStyle}>
          <ViewerDcm src={src} list={list} />
        </div>
      );
    }

    return (
      <div style={containerStyle}>
        <p className="no-preview" style={viewerClass}>
          {t('No preview available,')}
          {' '}
          <span onClick={openFile} aria-hidden="true">
            {t('Download')}
          </span>
        </p>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mimetype, name, src]);

  return attachmentJSX;
}

Viewer.propTypes = {
  name: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  mimetype: PropTypes.string.isRequired,
  list: PropTypes.array,
  file: PropTypes.object,
  containerStyle: PropTypes.object,
  viewerClass: PropTypes.object,
};

export default Viewer;
